module.exports = __webpack_public_path__ + "./img/favicon/homework/safari-pinned-tab.svg";